/* ============
 * VMP Sync Fields Popup
 * ============
 *
 */

import { mapGetters, mapMutations } from 'vuex';
import Forms from '../../utils/forms/forms';

export default {
  props: {
    onClose: {
      required: false,
      type: Function,
      default: () => {},
    },
    onConfirm: {
      required: true,
      type: Function,
      default: () => {},
    },
    selectedFields: {
      required: false,
      type: Array,
      default: [],
    },
    result: {
      required: true,
      type: Array,
      default: [],
    },
    hasNewSelection: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: new Forms({
        syncFields: {
          value: [],
          type: "checkboxGroup",
        },
      }),
      loading: false,
      fields: [],
    };
  },

  computed: {
    ...mapGetters({}),
  },

  created() {
    this.fields = this.$i18n.messages[
      this.$i18n.locale
    ].static.products.syncVmp.fields;
    this.form.setOptions(
      "syncFields",
      Object.keys(this.fields).map((key) => ({
        id: key,
        name: this.fields[key],
      }))
    );
    this.form.syncFields = this.selectedFields.map((f) => this.fields[f]) || [];
  },

  mounted() {
    this.loading = false;
  },

  watch: {
    result() {
      this.loading = false;
    },
  },

  methods: {
    ...mapMutations({
      toggle: "TOGGLE_MODAL",
      unsetModalContent: "UNSET_MODAL_CONTENT",
    }),

    confirm() {
      this.loading = true;
      const fields = Object.fromEntries(
        Object.entries(this.fields).map((a) => a.reverse())
      );
      this.onConfirm(this.form.syncFields.map((f) => fields[f]));
    },

    /*
     * Closes the modal
     */
    closeModal() {
      this.onClose();
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require("./../../components/form/form.vue"),
    VMessage: require("./../../components/form/message/message.vue"),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/vmpSyncFieldsPopup/vmpSyncFieldsPopup.js